import React from 'react';
import styles from './AnimatedVisuals.module.css';

const CloudVisual = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.cloudHeader}>
        <div className={styles.cloudIcon}>☁️</div>
        <span className={styles.cloudTitle}>Cloud Infrastructure</span>
      </div>
      <div className={styles.cloudScene}>
        <div className={styles.cloudServer}>
          <div className={styles.serverRack}>
            <div className={styles.serverSlot}></div>
            <div className={styles.serverSlot}></div>
            <div className={styles.serverSlot}></div>
            <div className={styles.serverSlot}></div>
          </div>
        </div>
        <div className={styles.cloudNodes}>
          <div className={styles.cloudNode} style={{ top: '10%', left: '20%' }}></div>
          <div className={styles.cloudNode} style={{ top: '30%', right: '15%' }}></div>
          <div className={styles.cloudNode} style={{ bottom: '20%', left: '15%' }}></div>
          <div className={styles.cloudNode} style={{ bottom: '10%', right: '25%' }}></div>
        </div>
        <svg className={styles.cloudConnections} viewBox="0 0 200 150">
          <line x1="40" y1="15" x2="170" y2="45" className={styles.connection} />
          <line x1="40" y1="15" x2="30" y2="130" className={styles.connection} />
          <line x1="170" y1="45" x2="175" y2="140" className={styles.connection} />
          <line x1="30" y1="130" x2="175" y2="140" className={styles.connection} />
        </svg>
      </div>
      <div className={styles.cloudStatus}>
        <span className={styles.statusDot}></span>
        <span>Scalable & Secure</span>
      </div>
    </div>
  );
};

export default CloudVisual;

